import React, { useMemo } from 'react';
import { Card } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

function MonthlyProductionDistribution({ productions }) {
    // Process data for monthly distribution
    const chartData = useMemo(() => {
        // Define months in Turkish
        const months = [
            'Ocak',
            'Şubat',
            'Mart',
            'Nisan',
            'Mayıs',
            'Haziran',
            'Temmuz',
            'Ağustos',
            'Eylül',
            'Ekim',
            'Kasım',
            'Aralık',
        ];

        // Initialize data with all months
        const data = months.map((name) => ({ name, active: 0, passive: 0 }));

        // Count productions by month
        productions.forEach((production) => {
            if (production.createdAt) {
                const date = new Date(production.createdAt);
                const monthIndex = date.getMonth();

                if (production.isActive) {
                    data[monthIndex].active++;
                } else {
                    data[monthIndex].passive++;
                }
            }
        });

        // Get current month index
        const currentMonthIndex = new Date().getMonth();

        // Reorder data to start from current month - 5 (showing last 6 months)
        let startIndex = currentMonthIndex - 5;
        if (startIndex < 0) startIndex += 12; // Wrap around to previous year

        const reorderedData = [];
        for (let i = 0; i < 6; i++) {
            const index = (startIndex + i) % 12;
            reorderedData.push(data[index]);
        }

        return {
            months: reorderedData.map((item) => item.name),
            active: reorderedData.map((item) => item.active),
            passive: reorderedData.map((item) => item.passive),
        };
    }, [productions]);

    return (
        <Card>
            <MDBox p={3}>
                <MDBox mb={2} display="flex" justifyContent="space-between">
                    <MDTypography variant="h5" fontWeight="medium">
                        Aylık Üretim Dağılımı
                    </MDTypography>
                </MDBox>
                <MDBox height="15.625rem">
                    <BarChart
                        dataset={chartData.months.map((month, index) => ({
                            month,
                            active: chartData.active[index],
                            passive: chartData.passive[index],
                        }))}
                        xAxis={[
                            {
                                scaleType: 'band',
                                dataKey: 'month',
                                tickLabelStyle: {
                                    angle: 0,
                                    textAnchor: 'middle',
                                    fontSize: 12,
                                },
                            },
                        ]}
                        series={[
                            {
                                dataKey: 'active',
                                label: 'Aktif',
                                valueFormatter: (value) => `${value} üretim`,
                                color: '#2e7d32',
                                stack: 'stack1',
                            },
                            {
                                dataKey: 'passive',
                                label: 'Pasif',
                                valueFormatter: (value) => `${value} üretim`,
                                color: '#d32f2f',
                                stack: 'stack1',
                            },
                        ]}
                        yAxis={[
                            {
                                scaleType: 'linear',
                                tickMinStep: 1,
                            },
                        ]}
                        height={250}
                        width="100%"
                        slotProps={{
                            legend: {
                                position: { vertical: 'bottom', horizontal: 'middle' },
                                itemMarkWidth: 10,
                                itemMarkHeight: 10,
                            },
                        }}
                    />
                </MDBox>
                <MDBox pt={2} display="flex" justifyContent="center">
                    <MDTypography variant="body2" color="text">
                        Son 6 ay içindeki üretim sayısı
                    </MDTypography>
                </MDBox>
            </MDBox>
        </Card>
    );
}

export default MonthlyProductionDistribution;
